export default __webpack_public_path__ + "static/media/Cek-Nilai.0c9f26e1.png";